var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmFacility = function SvgBmFacility(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16.392",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.142,24.46H.858a.858.858,0,1,0,0,1.716H17.142a.858.858,0,0,0,0-1.716Z",
    transform: "translate(0 -9.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.232,4.734l-5.5-2.49a.648.648,0,0,0-.906.6V4.572L2.27,2.3a.642.642,0,0,0-.93.6V14.376H13.232ZM6.32,12.126H3.752a.642.642,0,1,1,0-1.284H6.32a.642.642,0,0,1,0,1.284Zm0-3.216H3.752a.642.642,0,1,1,0-1.284H6.32a.642.642,0,1,1,0,1.284Zm4.5,3.216H8.252a.642.642,0,1,1,0-1.284H10.82a.642.642,0,0,1,0,1.284Zm0-3.216H8.252a.642.642,0,0,1,0-1.284H10.82a.642.642,0,0,1,0,1.284Z",
    transform: "translate(-0.536 -0.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.088.642A.642.642,0,0,0,25.446,0H22.872a.642.642,0,0,0-.642.642V13.5h3.858Z",
    transform: "translate(-8.892)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmFacility, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_Facility.b2c4c0c6.svg";
export { ForwardRef as ReactComponent };